import { useEventSlug } from '@/shared/hooks/useEventSlug'

/** @deprecated Use `useEventSlug`. */
export function useRouteDigitalProductId(): string {
  return useEventSlug()
}

export { useEventSlug } from '@/shared/hooks/useEventSlug'
